/* eslint-disable */
import { Reducer } from 'redux'
import { toast } from 'react-toastify'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'
import { API } from 'src/services/config'

export interface FarmProps {
  cidade: string
  dataCriacao: string
  descricao: string
  documento: string
  endereco: string
  estado: string
  id: string
  idFazenda: string
  key: string
  proprietario: string
  razao: string
}

export interface StoreProps {
  cidade?: string
  dataCriacao?: string
  descricao?: string
  documento: string
  endereco?: string
  estado?: string
  id?: string
  idFazenda?: string
  key?: string
  proprietario?: string
  razao?: string
}

export interface FarmState {
  isLoading: boolean
  list: Array<FarmProps>
}

const customModule = '@FARM'

const GET = {
  REQUEST: `${customModule}/GET_REQUEST`,
  SUCCESS: `${customModule}/GET_SUCCESS`
}

const UPDATE = {
  REQUEST: `${customModule}/UPDATE_REQUEST`,
  SUCCESS: `${customModule}/UPDATE_SUCCESS`
}

const initialState: FarmState = {
  isLoading: false,
  list: []
}

export const farmReducer: Reducer<FarmState> = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET.REQUEST:
      return { ...state, isLoading: true }

    case GET.SUCCESS:
      return { ...state, list: payload, isLoading: false }

    case UPDATE.SUCCESS: {
      const { list } = state
      const newList = list.map((item: any) => {
        if (item.idFazenda === payload.idFazenda) return payload
        return item
      })
      return { ...state, list: newList }
    }

    default:
      return state
  }
}

export const getFarm = (data: string) => ({ type: GET.REQUEST, payload: data })
export const updateFarm = (data: StoreProps) => ({ type: UPDATE.REQUEST, payload: data })

const ROUTE = '/entity/Fazenda'

// eslint-disable-next-line
function* get({ payload }: SagaAction<string>) {
  try {
    const { data }: GetResponse<any> = yield call(API.get, ROUTE)
    const farmToShow = data.filter((item: any) => item.idFazenda === payload)
    yield put({ type: GET.SUCCESS, payload: farmToShow })
  } catch (error: any) {
    const message = error?.response?.data || 'Erro ao buscar propriedades. Tente novamente.'
    toast.error(message)
  }
}

// eslint-disable-next-line
function* update({ payload }: SagaAction<StoreProps>) {
  try {
    const { data }: GetResponse<any> = yield toast.promise(API.put(ROUTE, payload), {
      pending: 'Processando...',
      success: {
        render() {
          return 'Atualizado com Sucesso!'
        },
        delay: 800
      },
      error: {
        render({ data: { response } }: any) {
          return response?.data || 'Erro ao Atualizar'
        },
        delay: 800
      }
    })
    yield put({ type: UPDATE.SUCCESS, payload: data })
  } catch (error) {
    console.error(error)
  }
}

export const farmSaga = all([takeLatest(GET.REQUEST, get), takeLatest(UPDATE.REQUEST, update)])
